import { MessageCircle } from "lucide-react";
import { MAPIA_WHATSAPP, waLink } from "../lib/whatsapp";

const WA = waLink(MAPIA_WHATSAPP, "Olá, preciso de ajuda com o MapIA.");

export const WhatsAppFab = () => (
  <a
    href={WA}
    target="_blank"
    rel="noreferrer"
    aria-label="Falar com o suporte no WhatsApp"
    title="Precisa de ajuda? Fale no WhatsApp"
    data-testid="whatsapp-fab"
    className="fixed z-40 right-4 bottom-4 sm:right-6 sm:bottom-6 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] text-white shadow-lg grid place-items-center transition-transform duration-200 hover:scale-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25D366]"
  >
    <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7" />
  </a>
);
